/**
 * modal
 */

export function modal() {

  document.addEventListener('DOMContentLoaded', function(){

    function handleResize(index) {
      var modalId = modalBtns[index].getAttribute('data-modal');
      if (modalId !== 'modal_search') {
        var modal = document.getElementById(modalId);
      }

      if (modal) {
        modal_search
        // モーダルのサイズを取得
        let modalSizeElement = modal.querySelector('.js-modal-size');
        let modalWidth = modalSizeElement.clientWidth;
        let modalHeight = modalSizeElement.clientHeight;

        // モーダル内の要素を取得（タブ）
        let colorsHeadSizeElement = modal.querySelector('.p-quick-modal-colors__head');
        if (colorsHeadSizeElement) {
          let tabHeadSizeElement = modal.querySelector('.tab-head');
          let modalHeadHeight = colorsHeadSizeElement.clientHeight;
          let modalTabHeadHeight = tabHeadSizeElement.clientHeight;
          let minusElement = modalHeadHeight + modalTabHeadHeight;

          document.documentElement.style.setProperty(`--${modalId}-inner-head-height`, minusElement + 'px');

          console.log({ modalWidth, modalHeight, modalHeadHeight, modalTabHeadHeight });
        }

        // モーダル内の要素を取得（Swiper）
        let swipperHeadElement = modal.querySelector('.p-quick-modal-size__head');
        let swipperSizeElement = modal.querySelector('.swiper-wrapper');

        if (swipperSizeElement) {
          let swipperHeadHeight = swipperHeadElement.clientHeight;
          let swiperHeight = swipperSizeElement.clientHeight;

          document.documentElement.style.setProperty(`--${modalId}-swiper-inner-height`, (swipperHeadHeight + swiperHeight) + 'px');
          document.documentElement.style.setProperty(`--${modalId}-slide-inner-height`, swiperHeight + 'px');

          console.log({ swipperHeadHeight, swiperHeight });
        }

        // ボタンをクリックしたら個別のカスタムプロパティにセット
        document.documentElement.style.setProperty(`--${modalId}-width`, modalWidth + 'px');
        document.documentElement.style.setProperty(`--${modalId}-height`, modalHeight + 'px');

      }
    }

    const modalBtns = document.querySelectorAll('.js-modal-open');
    modalBtns.forEach(function (btn, index) {
      btn.onclick = function () {
        var modalId = btn.getAttribute('data-modal');
        var modal = document.getElementById(modalId);
        if (modal) {
          // モーダルを表示
          modal.style.display = "block";
        }
        handleResize(index); // クリック時にもサイズを取得
      };
    });

    const closeBtns = document.querySelectorAll('.modal-close');
    closeBtns.forEach(function (btn) {
      btn.onclick = function () {
        var modal = btn.closest('.c-modal');
        if (modal) {
          modal.style.display = "none";
        }
      };
    });

    window.onclick = function (event) {
      if (event.target.classList.contains('c-modal')) {
        event.target.style.display = "none";
      }
    };

    // ウィンドウのリサイズイベントに対応
    window.addEventListener('resize', function() {
      modalBtns.forEach(function (btn, index) {
        handleResize(index);
      });
    });
  });
}
